var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCloseGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6054 12.6996L9.40567 7.49997L14.6054 2.3003C15.1315 1.77404 15.1315 0.920893 14.6054 0.394727C14.0792 -0.131621 13.226 -0.13153 12.6998 0.394727L7.5 5.5944L2.3003 0.394727C1.77404 -0.13153 0.920886 -0.13153 0.394627 0.394727C-0.131542 0.920893 -0.131542 1.77404 0.394627 2.3003L5.59433 7.49997L0.394627 12.6996C-0.131542 13.2259 -0.131542 14.0791 0.394627 14.6053C0.920886 15.1316 1.77404 15.1316 2.30039 14.6053L7.50009 9.40564L12.6998 14.6053C13.226 15.1316 14.0792 15.1316 14.6054 14.6053C15.1315 14.0791 15.1315 13.2259 14.6054 12.6996Z",
  fill: "#AEAEAE"
})));
export default __webpack_public_path__ + "static/media/icon_close_grey.ea69f7a9.svg";
export { SvgIconCloseGrey as ReactComponent };